module.exports = __webpack_public_path__ + "img/BBB Logo l Black.a5cdbdbf.svg";